module.exports = __webpack_public_path__ + "img/realized-semipublic.ba281ad4.svg";